// extracted by mini-css-extract-plugin
export default {"reqInvTran":"Inventory_reqInvTran__MeQdA"};